import { SECOND_MS } from '@anm/constants/date';
import formatTime from '@anm/helpers/time/formatTime';
import { useEffect, useState, FC } from 'react';
import { LiveStreamStatus } from 'types/stream';

import { StreamTextItem } from '../Wrapper';

type ProgressTimeProps = {
  state: LiveStreamStatus;
  startedAt: number;
  lastStartedTime: number | null;
  pausedDuration?: number;
};

const getLiveTime = ({ startedAt, lastStartedTime, pausedDuration }: ProgressTimeProps) =>
  lastStartedTime && pausedDuration
    ? (Date.now() - lastStartedTime + pausedDuration * SECOND_MS) / SECOND_MS
    : (Date.now() - startedAt) / SECOND_MS;

const ProgressTime: FC<ProgressTimeProps> = props => {
  const [time, setTime] = useState(getLiveTime(props));

  const updateTime = () => setTime(prevTime => prevTime + 1);

  useEffect(() => {
    if (props.state === 'PAUSED') return setTime(0);
    else setTime(getLiveTime(props));

    const timeId = setInterval(updateTime, SECOND_MS);

    return () => {
      clearInterval(timeId);
    };
  }, [props.state, props.lastStartedTime]);

  return <StreamTextItem variant="small-grey">{formatTime(time)}</StreamTextItem>;
};

export default ProgressTime;
